import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect } from "react";
import { AuthContext } from "@/components/AuthProvider";
import { useDashboardRouter } from "@/hooks/useDashboardRouter";
import { parseCodesmithExtensionSetUiExperiment, postCodesmithExtensionUiExperiments, useCodesmithExtensionSettingsAvailable } from "@/lib/codesmithExtensionBridge";
import { useCodesmithSurface } from "@/lib/codesmithSurface";
import { isChatExperimentKey, setExperiment, useChatExperimentDescriptors } from "./chatExperiments";

/**
 * Lets the extension panel list and flip the browser-local chat experiments of
 * the dashboard it frames; writes go through `setExperiment`, so the framed
 * dashboard updates live.
 */
function useChatExperimentsExtensionBridge(active) {
  const $ = _c(7);
  const experiments = useChatExperimentDescriptors();
  let t0;
  let t1;
  if ($[0] !== active || $[1] !== experiments) {
    t0 = () => {
      if (!active) {
        return;
      }
      postCodesmithExtensionUiExperiments(experiments);
    };
    t1 = [active, experiments];
    $[0] = active;
    $[1] = experiments;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[4] !== active) {
    t2 = () => {
      if (!active) {
        return;
      }
      const handleMessage = _temp;
      const clear = _temp2;
      window.addEventListener("message", handleMessage);
      window.addEventListener("pagehide", clear);
      return () => {
        window.removeEventListener("message", handleMessage);
        window.removeEventListener("pagehide", clear);
        clear();
      };
    };
    t3 = [active];
    $[4] = active;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
}

/**
 * Mounted by the Codesmith shell rather than the flask, which yields its
 * corner to composer chrome and is absent from new-session drafts, so the
 * panel's UI experiments stay listed on every Codesmith route.
 */
function _temp2() {
  return postCodesmithExtensionUiExperiments([]);
}
function _temp(event) {
  const request = parseCodesmithExtensionSetUiExperiment(event);
  if (request !== null && isChatExperimentKey(request.key)) {
    setExperiment(request.key, request.value);
  }
}
export function ChatExperimentsExtensionBridge() {
  const $ = _c(2);
  const {
    user
  } = useContext(AuthContext);
  const router = useDashboardRouter();
  const embedded = useCodesmithSurface(router.query.embed) === "extension";
  let t0;
  if ($[0] !== embedded) {
    t0 = {
      embedded
    };
    $[0] = embedded;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const rolloutsAvailable = useCodesmithExtensionSettingsAvailable("rollouts", t0);
  useChatExperimentsExtensionBridge(embedded && rolloutsAvailable && user?.is_superuser === true);
  return null;
}